import script from "./SubscriptionConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionConfirm.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionConfirm.vue?vue&type=style&index=0&id=6bb49513&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb49513"]])

export default __exports__